export const ICON_HEIGHT = 16;